import { useAdminUpdate } from '@reapitform/hooks'
import { AdminEventTemplate, AdminEventTemplatePayload } from '../types'

/** Creates an event template under a form version
 * (`POST /api/forms/{formRef}/versions/{versionRef}/event-templates`). */
export const useCreateAdminEventTemplate = (formReferenceID: string, versionReferenceID: string) =>
  useAdminUpdate<AdminEventTemplatePayload, AdminEventTemplate>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/event-templates`,
    method: 'POST',
    errorMessage: 'Failed to create the notification',
    successMessage: 'Notification created',
  })
